<template>
	<!--	</div>-->
	<div :class="{'sticky top-0 z-10': sticky }">
        <TabMenu :active-index="activeIndex" :model="tabs" class="tab-menu-container m-0 px-0 bg-white">
            <template #item="{ item, props, active }">
                <router-link v-if="item.to" v-slot="{ href, navigate }" :to="item.to" custom>
                    <a v-ripple :href="href" v-bind="props.action" @click="navigate" :class="{'opacity-50': item.disabled}">
                        <span v-bind="props.icon"/>
                        <span v-bind="props.label">{{ item.label }}</span>
                    </a>
                </router-link>
                <a v-else v-ripple :href="item.url" :target="item.target" v-bind="props.action">
                    <span v-bind="props.icon"/>
                    <span :data-cy="`${item.label}`" v-bind="props.label">{{ item.label }}</span>
                </a>
            </template>
		</TabMenu>
	</div>

	<slot></slot>
</template>

<script>
import TabMenu from "primevue/tabmenu";

export default {
	name: "TabLayout",
	data() {
		return {
			activeIndex: 0
		}
	},
	components: {
		TabMenu,
	},
	props: {
		sticky: Boolean,
		tabs: {
			type: Array,
			default: [],
			required: true,
			validator(value) {
				return value.length > 0;
			}
		},
	},
	watch: {
		tabs: {
			handler: function (newValue, oldValue) {
				let activeIndex = newValue?.findIndex(i => i.current);
				this.activeIndex = Math.max(0, activeIndex);
			},
			immediate: true,
		},
	},
}
</script>

<style scoped>

@media screen and (min-width:768px) {
    .tab-menu-container ul li:first-child > a {
        margin-left: 25px !important;
        display: block;
    }
}
</style>
